var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9866_106541)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9866_106541)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_9866_106541)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.90156 3.75156C9.90156 3.25451 9.49862 2.85156 9.00156 2.85156C8.50451 2.85156 8.10156 3.25451 8.10156 3.75156V8.10156H3.75156C3.25451 8.10156 2.85156 8.50451 2.85156 9.00156C2.85156 9.49862 3.25451 9.90156 3.75156 9.90156H8.10156V14.2516C8.10156 14.7486 8.50451 15.1516 9.00156 15.1516C9.49862 15.1516 9.90156 14.7486 9.90156 14.2516V9.90156H14.2516C14.7486 9.90156 15.1516 9.49862 15.1516 9.00156C15.1516 8.50451 14.7486 8.10156 14.2516 8.10156H9.90156V3.75156Z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9866_106541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9866_106541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_9866_106541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.1bfd11bf06dc4f20e3d6cce8b7d8f875.svg";
export { ForwardRef as ReactComponent };